import { FormControlLabel, Radio, RadioGroup, TextField, Typography } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import DateFnsUtils from '@date-io/date-fns';
import enLocale from 'date-fns/locale/en-GB';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import React from 'react';
import IdentificationDocumentActions from './IdentificationDocumentActions';
import Button from '@material-ui/core/Button';
import { actionCreators as selfServiceActionCreators } from '../../redux/actions/selfServiceActions';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import { useHistory, useParams, useRouteMatch } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import dayjs from 'dayjs';
import { CheckCircleOutline, VerifiedUser, WarningOutlined } from '@material-ui/icons';

require("dayjs/locale/en-gb");

const basicRowStyle = { display: `flex`, flexDirection: `row`, justifyContent: `space-between`, marginTop: `20px` };
const IdentificationDocument = (props) => {
	const dispatch = useDispatch();
	const history = useHistory();
	const location = useRouteMatch();
	const allParams = useParams();
	const {
		identificationDocument,
		countriesList,
		setFieldState,
		addingMode,
		removeIdentificationDocument,
		showSnackBar,
		fieldError,
		setFieldError,
		readOnlyMode,
	} = props;
	const {
		ID,
		DocumentType,
		DocumentTypeName,
		Expires,
		DocumentIssueDate,
		DocumentID,
		DocumentExpiryDate,
		IssuingCountry,
		InScopeDocument,
		SelfServiceDocument,
		VerificationStatus,
		UserDecision,
	} = identificationDocument;

	const VerificationStatusMapper = {
		'Pending': 'Pending',
		'Verified': 'Verified',
		'ResubmissionRequested': 'Resubmission Required',
		'Review': 'Reviewing',
		'Declined': 'Not Valid'
	};

	const displayVerificationStatus = VerificationStatusMapper[VerificationStatus];

	const handleChange = (property, value) => {
		const newIdentificationDocument = { ...identificationDocument, [property]: value };
		setFieldError(null);
		setFieldState(newIdentificationDocument);
	};
	const handleRemoveIdentificationDocument = async () => {
		await removeFile();
		removeIdentificationDocument(identificationDocument);
	};

	const removeFile = async () => {
		if (identificationDocument.SelfServiceDocument?.BaseDocumentId) {
			setFieldError(null);
			const fileId = identificationDocument.SelfServiceDocument?.BaseDocumentId;
			await dispatch(selfServiceActionCreators.deleteIdentificationDocument(allParams.entityId, fileId));
		}
	};

	const upload = () => {
		history.push(`${location.url}/id-verification`);
	};

	return (
		<fieldset className='entity-fieldset'>
			<Typography component='legend' color='primary'>
				<legend>
					{readOnlyMode ? `${DocumentTypeName} (${displayVerificationStatus} and ${UserDecision})` : DocumentTypeName}
					{
						fieldError ?
							<Typography variant="body2" color="error">
								{fieldError}
							</Typography>
							: ""
					}
				</legend>
			</Typography>
			{addingMode && !readOnlyMode && (
				<div style={{ justifyContent: 'flex-end', display: 'flex', marginBottom: '40px' }}>
					<Button onClick={handleRemoveIdentificationDocument} color='secondary' startIcon={<DeleteForeverIcon />}>
						Remove Identification Document
					</Button>
				</div>
			)}

			{/* First Row */}
			<div style={basicRowStyle}>
				{/* Doc Type */}
				{/* <TextField label='Type' disabled value={DocumentType} variant='filled' /> */}

				{/* Doc Id number */}
				<TextField label='Document ID' disabled value={DocumentID} variant='filled' />

				{/* Countries */}
				<Autocomplete
					id='auto-complete-id-docs-countries'
					style={{ width: 220 }}
					value={countriesList.find((c) => c.Code === IssuingCountry)}
					onChange={(event, newValue) => {
						handleChange('IssuingCountry', newValue.Code);
					}}
					options={countriesList}
					getOptionLabel={(option) => option.Name}
					renderInput={(params) => <TextField {...params} label='Countries' variant='outlined' />}
					disabled={readOnlyMode}
				/>

				{/* Doc Issue Date */}
				{/* <TextField label='Issue Date' disabled value={DocumentIssueDate} variant='filled' /> */}
				<LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='en-gb'>
					<DatePicker
						disabled={!addingMode || readOnlyMode}
						autoOk
						label='Issue Date'
						format="DD-MMMM-YYYY"
						slotProps={{ textField: { variant: 'filled' } }}
						value={DocumentIssueDate ? dayjs(DocumentIssueDate) : null}
						onChange={(newValue) => {
							handleChange(`DocumentIssueDate`, newValue?.$d);
						}}
					/>
				</LocalizationProvider>
			</div>

			{/* Second row */}
			<div style={basicRowStyle}>
				{/* Doc Expires */}
				<div style={{ marginBottom: `20px` }}>
					<p style={{ margin: `0` }}>Has Expiry Date?</p>
					<RadioGroup
						value={Expires?.toString()}
						onChange={(event, value) => {
							handleChange(`Expires`, value === `true`);
						}}
						style={{ display: `flex`, flexDirection: `row`, justifyContent: `space-between`, alignItems: `center` }}
					>
						<FormControlLabel value={'true'} control={<Radio />} label='Yes' disabled={readOnlyMode} />
						<FormControlLabel value={'false'} control={<Radio />} label='No' disabled={readOnlyMode} />
					</RadioGroup>
				</div>
				{/* Doc Expiry Date*/}
				{Expires && (
					<LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='en-gb'>
						<DatePicker
							autoOk
							required
							label='Expiry Date'
							format="DD-MMMM-YYYY"
							slotProps={{ textField: { variant: 'filled' } }}
							value={DocumentExpiryDate ? dayjs(DocumentExpiryDate) : null}
							onChange={(newValue) => {
								handleChange(`DocumentExpiryDate`, newValue?.$d);
							}}
							disabled={readOnlyMode}
						/>
					</LocalizationProvider>
				)}
			</div>

			{/* Actions  */}
			{!readOnlyMode &&
				<div style={{ marginTop: 100 }}>
					{InScopeDocument && (
						<div style={{ ...basicRowStyle, alignItems: `center`, justifyContent: `flex-start` }}>
							<small style={{ width: 150, margin: 20 }}>Latest document available</small>
							<IdentificationDocumentActions
								showSnackBar={showSnackBar}
								document={InScopeDocument}
								documentType={DocumentType}
								allowRemoveDocument={false}
								allowAddDocument={false}
								setFieldError={setFieldError}
								documentName={DocumentID}
								isInScopeDocument={true}
							/>
						</div>
					)}
					<div style={{ ...basicRowStyle, alignItems: `center`, justifyContent: `flex-start` }}>
						<small style={{ width: 150, margin: 20 }}>Your upload</small>
						<IdentificationDocumentActions
							showSnackBar={showSnackBar}
							document={SelfServiceDocument}
							documentType={DocumentType}
							allowRemoveDocument={SelfServiceDocument}
							allowAddDocument={!SelfServiceDocument}
							setFieldError={setFieldError}
							addIdentificationDocumentFile={(newIdentificationDocumentFile) =>
								handleChange('SelfServiceDocument', newIdentificationDocumentFile)
							}
							deleteIdentificationDocument={() => handleChange(`SelfServiceDocument`, null)}
							documentName={DocumentID}
							isInScopeDocument={false}
						/>
					</div>
				</div>
			}

			{readOnlyMode && (VerificationStatus === "Pending" || VerificationStatus === "ResubmissionRequested" || UserDecision === "Skipped") && UserDecision !== 'Updated' && (
				<Button type="submit" variant='contained' color='primary' startIcon={<VerifiedUser />} onClick={(e) => { e.preventDefault(); upload(); }} title='Verify Now'>Verify Now</Button>
			)}
			{readOnlyMode && VerificationStatus === "Verified" && (
				<span style={{ color: 'green', display: 'flex', alignItems: 'center' }}>
					<VerifiedUser style={{ marginRight: '5px' }} /> Document Valid
				</span>
			)}
		</fieldset>
	);
};

export default IdentificationDocument;
